import CopyCoupon from './CopyCoupon';
import couponCreateComponent from './couponCreateComponent';
import couponExportReportComponent from './couponExportReportComponent';
import couponListComponent from './couponListComponent';

export default {
  CopyCoupon,
  couponCreateComponent,
  couponExportReportComponent,
  couponListComponent,
};
